import {Ban, CheckSquare} from "lucide-react";
import React from "react";
import Swal from 'sweetalert2';
import useApi from "../../../utils/useApi";
import {useNavCount} from "../../../contexts/NavCountProvider";

const PortalActions = ({ client, onRefresh, onDeny, className }) => {
    const { refreshCounts } = useNavCount();

    const { approvePortalRequest, denyPortalRequest } = useApi();
    const handleDenyRequest = async (client) => {
        const result = await Swal.fire({
                                           title: 'Deny Portal Request',
                                           text: `Do you want to deny portal request of ${client.client_id}?`,
                                           icon: 'warning',
                                           showCancelButton: true,
                                           confirmButtonColor: '#ef4444',
                                           cancelButtonColor: '#6b7280',
                                           confirmButtonText: 'Yes, deny request',
                                           cancelButtonText: 'Cancel',
                                           background: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
                                           color: document.documentElement.classList.contains('dark') ? '#ffffff' : '#000000'
                                       });

        if (result.isConfirmed) {
            const response = await denyPortalRequest(client.id);

            if (response.success) {
                onDeny();
                refreshCounts();
            } else {
                await Swal.fire({
                                    title: 'Error!',
                                    text: response.message,
                                    icon: 'error',
                                    showConfirmButton: true
                                });
            }
        }
    };

    const handleApproveRequest = async (client) => {
        const result = await Swal.fire({
                                           title: 'Approve Portal Request',
                                           text: `Do you want to approve portal request of ${client.client_id}?`,
                                           icon: 'question',
                                           showCancelButton: true,
                                           confirmButtonColor: '#22c55e',
                                           cancelButtonColor: '#6b7280',
                                           confirmButtonText: 'Yes, approve request',
                                           cancelButtonText: 'Cancel',
                                           background: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
                                           color: document.documentElement.classList.contains('dark') ? '#ffffff' : '#000000'
                                       });

        if (result.isConfirmed) {
            const response = await approvePortalRequest(client.id);

            console.log(response);
            if (response.success) {
                onRefresh();
                refreshCounts();
            } else {
                await Swal.fire({
                                    title: 'Error!',
                                    text: response.message,
                                    icon: 'error',
                                    showConfirmButton: true
                                });
            }
        }
    };
    return (
        <div className={`${className} flex gap-2 min-[767px]:flex-wrap`}>
            <button
                onClick={() => handleApproveRequest(client)}
                className="inline-flex items-center justify-center px-3 py-2 border border-green-500 text-green-500 hover:bg-green-500 hover:text-white rounded transition-colors text-xs"
            >
                <CheckSquare className="w-4 h-4 mr-2"/>
                Approve
            </button>
            <button
                onClick={() => handleDenyRequest(client)}
                className=" inline-flex items-center justify-center px-3 py-2 border border-red-500 text-red-500 hover:bg-red-500 hover:text-white rounded transition-colors text-xs"
            >
                <Ban className="w-4 h-4 mr-2"/>
                Deny
            </button>
        </div>

    )
}

export default PortalActions;
